<script>
import {loadModelRelations} from "@/helpers/utils";
import Loader from "@/components/loader.vue";

export default {
  name: "Detail",
  components: {
    Loader
  },
  props: {
    value: null,
    relations: {
      type: String,
      default: ''
    },
    then: {
      type: Function,
      default: () => {
      }
    }
  },
  data() {
    return {
      isLoading: true
    };
  },
  mounted() {
    loadModelRelations(this.value, this.relations).then(() => {
      this.then();
    }).finally(() => {
      this.isLoading = false;
    });
  }
};
</script>

<template>
  <b-card no-body>
    <loader :loading="isLoading"></loader>
    <b-row v-if="!isLoading" no-gutters v-once>
      <slot></slot>
    </b-row>

    <b-card-footer class="text-right">
      <b-row v-if="!isLoading" v-once>
        <slot name="footer"></slot>
      </b-row>
    </b-card-footer>
  </b-card>
</template>
